// src/App.js
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  BrowserRouter,
} from "react-router-dom";
import Dashboard from "./pages/dashboard/dashboard";
import Offers from "./pages/dashboard/pages/offers/Offers";
import TypeOffers from "./pages/dashboard/pages/typeOffers/typeOffer";
import routes from "./pages";
import Header from "./components/header/Header";
import AOS from "aos";
import Page404 from "./pages/404";
import Ventes from "./pages/dashboard/pages/ventes/ventes";
import Users from "./pages/dashboard/pages/users/users";
import PaymentModal from "./components/PaymentModal"; // {{ edit_3 }}
import ClientVentes from "./pages/dashboard/pages/clientVentes/clientVentes";
import Currencies from "./pages/dashboard/pages/currencies/currencies";
import Achat from "./pages/dashboard/achat/achat";
import Clients from "./pages/dashboard/pages/clients/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Buy from "./components/fpages/Buy";
import Cheap from "./components/fpages/Cheap";
import FastDelivery from "./components/fpages/Fast";
import BestPlace from "./components/fpages/Best";
import SellCoinsSafely from "./components/fpages/Sell";

import Messages from "./pages/dashboard/messages/messages";
import AdminRoute from "./middleware/adminRoute";
import PageTitle from "./pageTitle";
import { HelmetProvider } from "react-helmet-async";
import AverageAmountManager from "./pages/dashboard/average/average";
import DashboardCards from "./pages/dashboard/DashboardCards";
import { PaymentProvider } from "./middleware/PaymentContext";
import CouponsManager from "./pages/dashboard/coupons/coupons";

import ClientDashboard from "./pages/clientDashboard/ClientDashboard";
import ClientRoute from "./middleware/ClientRoute";

import OrderDetail from "./pages/clientDashboard/orders/OrderDetail";
import Orders from "./pages/clientDashboard/orders/Orders";
import Overview from "./pages/clientDashboard/overview/Overview";
import Balance from "./pages/clientDashboard/balance/Balance";
import Settings from "./pages/clientDashboard/settings/Settings";
import Chat from "./pages/clientDashboard/message/Chat";
import WelcomePopup from "./components/WelcomePopup";
import HourlyWelcomePopup from "./components/HourlyWelcomePopup";
import TermsOfService from "./components/terms/TermService";
import PrivacyNotice from "./components/terms/PrivacyNotice";
import RefundPolicy from "./components/terms/RefundPolicy";
import SettingsLayout from "./pages/clientDashboard/settings/components/SettingsLayout";

import Demandes from "./pages/dashboard/remboursements/Demandes";
import AdminVerifications from "./pages/dashboard/verifications/Verifications";
import PaymentSettings from "./pages/dashboard/settings/PaymentSettings";
import SystemSettings from "./pages/dashboard/settings/SystemSettings";
import { CurrencyProvider } from "./context/CurrencyContext";


const googleClientId =
  process.env.GOOGLE_CLIENT_ID ||
  "468771891072-6p52o9t54r2berc13u49l365udj9ripd.apps.googleusercontent.com";

function App() {
  const [isLogin, setIslogin] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      setIslogin(true);
    } else {
      setIslogin(false);
    }
    AOS.init({
      duration: 2000,
    });
  }, []);

  return (
    <CurrencyProvider>
      <PaymentProvider>
        <GoogleOAuthProvider clientId={googleClientId}>
          <HelmetProvider>
            {/* <HourlyWelcomePopup /> */}
            <div>
              {/* <WelcomePopup /> */}
              <PageTitle />

              <Routes>
                <Route path="dashboard/*" element={<Outlet />} />
                <Route path="client-dashboard/*" element={<Outlet />} />
                <Route path="*" element={<Header islogin={isLogin} />} />
              </Routes>

              <Routes>
                {routes.map((data, idx) => (
                  <Route
                    key={idx}
                    path={data.path}
                    element={data.component}
                    exact
                  />
                ))}
                <Route
                  path="/dashboard"
                  element={<AdminRoute element={<Dashboard />} />}
                >
                  <Route index element={<DashboardCards />} />
                  <Route path="offers" element={<Offers />} />
                  <Route path="typeoffers" element={<TypeOffers />} />
                  <Route path="ventes" element={<Ventes />} />
                  <Route path="users" element={<Users />} />
                  <Route path="clientVentes" element={<ClientVentes />} />
                  <Route path="currencies" element={<Currencies />} />
                  <Route path="achat" element={<Achat />} />
                  <Route path="client" element={<Clients />} />
                  <Route path="messages" element={<Messages />} />
                  <Route path="refund" element={<Demandes />} />
                  <Route path="verifications" element={<AdminVerifications />} />
                  <Route path="average" element={<AverageAmountManager />} />
                  <Route path="coupons" element={<CouponsManager />} />
                  <Route path="chat" element={<Chat />} />
                  <Route path="setting" element={<Settings />} />
                  <Route path="settingsPayment" element={<PaymentSettings />} />
                  <Route path="settingsSystem" element={<SystemSettings />} />
                </Route>
                <Route
                  path="/client-dashboard"
                  element={<ClientRoute element={<ClientDashboard />} />}
                >
                  <Route index element={<ClientDashboard />} />
                  <Route path="orders" element={<ClientDashboard />} />
                  <Route path="ventes" element={<ClientDashboard />} />
                  <Route path="ventes" element={<ClientDashboard />} />
                  <Route path="coupons" element={<ClientDashboard />} />
                  <Route path="balance" element={<ClientDashboard />} />
                  <Route path="settings" element={<ClientDashboard />} />
                  <Route path="chat" element={<ClientDashboard />} />
                  {/* <Route path="orders/:id" element={<OrderDetail />} /> */}
                </Route>

                <Route path="*" element={<Page404 />} />
                <Route path="buy-fc-coins" element={<Buy />} />
                <Route
                  path="best-place-to-buy-fc-coins"
                  element={<BestPlace />}
                />
                <Route path="fast-fc-coins-delivery" element={<FastDelivery />} />
                <Route path="cheap-fc-coins" element={<Cheap />} />
                <Route path="terms" element={<TermsOfService />} />
                <Route path="privacy" element={<PrivacyNotice />} />
                <Route path="refund-promise" element={<RefundPolicy />} />
              </Routes>
            </div>
          </HelmetProvider>
        </GoogleOAuthProvider>
      </PaymentProvider>
    </CurrencyProvider>
  );
}

export default App;
